import React from "react";
import { ExplorePremiumLoaderTemplate } from "themes/application/payment/components";

function ExplorePremiumLoader(props) {
    return <ExplorePremiumLoaderTemplate {...props} />;
}

export default ExplorePremiumLoader;
